module.exports = __webpack_public_path__ + "static/media/8.c7211d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gifts/flowers/8.png
// module id = 134
// module chunks = 0